<template>
  <div class="padding border border-gray-200 relative rounded-lg flex items-center justify-center w-80 h-36">
    <span class="font-medium">Inset</span>
    <input-with-unit v-model="top" :alternative-units="['px', '%', 'vh']" class="padding-field" size="full" @updated="setData" />
    <input-with-unit v-model="right" :alternative-units="['px', '%', 'vw']" class="padding-field" size="full" @updated="setData" />
    <input-with-unit v-model="bottom" :alternative-units="['px', '%', 'vh']" class="padding-field" size="full" @updated="setData" />
    <input-with-unit v-model="left" :alternative-units="['px', '%', 'vw']" class="padding-field" size="full" @updated="setData" />
  </div>
</template>
<script>
import appearanceChangerMixin from "@/mixins/campaign-builder/appearance-changer-mixin"
import InputWithUnit from "@/components/common/InputWithUnit"

export default {
  name: "Padding",
  components: { InputWithUnit },
  mixins: [appearanceChangerMixin],
  data() {
    return {
      top: {},
      right: {},
      bottom: {},
      left: {}
    }
  },
  methods: {
    setData() {
      if (isNaN(this.top.value) || this.top.value === "") {
        this.top.value = 0
      }
      if (isNaN(this.right.value) || this.right.value === "") {
        this.right.value = 0
      }
      if (isNaN(this.bottom.value) || this.bottom.value === "") {
        this.bottom.value = 0
      }
      if (isNaN(this.left.value) || this.left.value === "") {
        this.left.value = 0
      }
      const str = `${this.top.value}${this.top.unit} ${this.right.value}${this.right.unit} ${this.bottom.value}${this.bottom.unit} ${this.left.value}${this.left.unit}`
      this.setStyleVariableDirect({
        env: this.env,
        value: str,
        variable: this.variable
      })
    }
  },
  created() {
    const data = this.getStyleVariableValue(this.env, this.variable, 2)
    this.top = {
      value: data[0].value,
      unit: data[0].unit
    }
    this.right = {
      value: data[1].value,
      unit: data[1].unit
    }
    this.bottom = {
      value: data[2].value,
      unit: data[2].unit
    }
    this.left = {
      value: data[3].value,
      unit: data[3].unit
    }
  }
}
</script>
<style lang="scss">
.padding {
  &-field {
    @apply absolute;
    max-width: 6.25rem;

    &:nth-of-type(1) {
      @apply top-2 left-1/2 transform -translate-x-1/2;
    }

    &:nth-of-type(2) {
      @apply top-1/2 right-2 transform -translate-y-1/2;
    }

    &:nth-of-type(3) {
      bottom: 0.5rem;
      left: 50%;
      transform: translateX(-50%);
    }

    &:nth-of-type(4) {
      top: 50%;
      transform: translateY(-50%);
      left: 0.5rem;
    }
  }
}
</style>
